// extracted by mini-css-extract-plugin
module.exports = {"root":"Icons_root__3fUB-"};